<template>
  <v-app class="rounded">
    <v-container fluid>
      <v-card elevation="2" outlined>
        <v-card-title>
          <!--                                    v-if="$can('transaction_create')"-->
          <v-btn
            @click="openModal"
            class="btn-add-with-text"
            v-status="'message_create_and_update'"
          >
            <v-icon>mdi-plus</v-icon>
            افزودن پیام
          </v-btn>
          <!--          <v-spacer/>-->
          <!--          {{ $t($route.meta.title) }}-->
          <!--          <v-spacer/>-->
          <!--          <v-btn :loading="loading" @click="reloadTable(tableProps)" class="btn-update">-->
          <!--            <v-icon>mdi-refresh</v-icon>-->
          <!--            به روزرسانی-->
          <!--          </v-btn>-->
        </v-card-title>
        <v-divider />
        <div class="row">
          <div class="col-md-12 p-5">
            <data-table
              orderDir="desc"
              :data="data"
              :columns="columns"
              :debounce-delay="5000"
              :translate="translates"
              :per-page="perPages"
              @on-table-props-changed="reloadTable"
            >
            </data-table>
          </div>
        </div>
      </v-card>
    </v-container>
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="showCreateModal"
      persistent
      max-width="800"
    >
      <template v-slot:default="showCreateModal">
        <v-card>
          <v-toolbar color="#b54405" class="font-weight-bold" dark>
            <v-icon class="pl-1">mdi-mail</v-icon>
            <span v-if="!update">ثبت پیام جدید</span>
            <span v-else>بروزرسانی پیام</span>
            <v-spacer></v-spacer>
            <v-btn
              small
              icon
              rounded
              @click="cancelCreate"
              class="ml-1 text-hover-danger text-white"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-row class="mt-5">
              <v-flex class="p-2" xs12 sm12 md6 xl6 lg6>
                <v-text-field
                  outlined
                  label="عنوان"
                  v-model="title"
                  dense
                  :error-messages="errors.title"
                ></v-text-field>
              </v-flex>
              <v-flex class="p-2" xs12 sm12 md6 xl6 lg6>
                <v-autocomplete
                  :items="messageCategories.data"
                  item-text="title"
                  v-model="category_id"
                  item-value="id"
                  :error-messages="errors.category_id"
                  :search-input.sync="search"
                  outlined
                  dense
                  label="انتخاب دسته بندی"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          @keydown.enter="
                            createCategory(messageCategories.data)
                          "
                        >
                          دسته بندی "<strong>{{ search }}</strong
                          >" یافت نشد.برای افزودن روی <kbd>Enter</kbd> کلیک
                          کنید. .
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template slot="item" slot-scope="{ item, tile }">
                    <div>{{ item.title }}</div>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-row>
            <v-row v-if="!all">
              <v-flex class="p-2" xs12 sm12 md6 xl6 lg6>
                <UsersComponent
                  v-model="user_id"
                  :errors="errors.user_id"
                  @changeUserId="user_id = null"
                ></UsersComponent>
              </v-flex>
              <!--                                :disabled="pack_id!==null"-->
              <v-flex class="p-2" xs12 sm12 md6 xl6 lg6>
                <v-autocomplete
                  :items="packs"
                  item-text="title"
                  clearable
                  v-model="pack_id"
                  item-value="id"
                  outlined
                  dense
                  label="انتخاب پنل"
                >
                  <!--                    :disabled="user_id!==null"-->
                  <template slot="item" slot-scope="{ item, tile }">
                    <div>{{ item.title }}</div>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-row>
            <v-row>
              <v-container fluid>
                <v-textarea
                  v-model="description"
                  :error-messages="errors.description"
                  label="متن پیام"
                  counter
                  outlined
                ></v-textarea>
                <p class="mx-2" style="margin-top: -20px">
                  <span v-text="'تعداد پیامک'"></span> :
                  <span class="font-weight-bold" v-text="' ' + smsCount"></span>
                </p>
              </v-container>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-checkbox
              color="orange darken-3"
              label="برای همه"
              @change="createAll"
              v-model="all"
            ></v-checkbox>
            <v-spacer />
            <v-btn class="btn-cancel" @click="cancelCreate">
              <v-icon>mdi-close-circle</v-icon>
              بستن
            </v-btn>
            <v-btn v-if="update" class="btn-update" @click="updateMessage">
              <v-icon>mdi-update</v-icon>
              بروزرسانی
            </v-btn>
            <v-btn v-else class="submit-btn" @click="store">
              <span class="fa fa-bookmark icon-md ml-1"></span>
              ذخیره
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-app>
</template>

<script>
import Button from "@/view/pages/Button";
import UsersComponent from "@/view/pages/admin/Messages/UsersComponent";
import { getTextSmsInfo } from "@/Utilities/Utilities";

export default {
  name: "Index",
  components: { UsersComponent },
  data() {
    return {
      id: null,
      all: false,
      smsCount: 0,
      pack_id: null,
      packs: [],
      category_id: null,
      search: null,
      page: 1,
      loading: false,
      update: false,
      messageCategories: [
        // {id: null, title: 'همه'}
      ],
      title: null,
      description: null,
      showCreateModal: false,
      showEditModal: false,
      user_id: null,
      data: {},
      errors: [],
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      columns: [
        {
          label: "شناسه",
          name: "id",
          orderable: true,
        },
        {
          label: "عنوان",
          name: "title",
          orderable: true,
        },
        {
          label: "کاربر",
          name: "user_id",
          transform: (val) => {
            if (val.data.user_id === null) {
              return "ندراد";
            }
            return val.data.users.username;
          },
        },
        {
          label: "دسته بندی",
          name: "category_id",
          transform: ({ data }) => {
            if (data.category_id === null) {
              return "ندراد";
            }
            return data.category.title;
          },
        },
        {
          label: "پنل",
          name: "pack_id",
          transform: ({ data }) => {
            if (data.pack_id === null) {
              return "ندراد";
            }
            return data.pack.title;
          },
        },

        {
          label: "متن پیام",
          name: "description",
          transform: (val) => {
            return `<p class="text-truncate " style="width: 12rem">${val.data.description}</p>`;
          },
        },
        {
          label: "عملیات",
          name: "actions",
          handler: this.actions,
          component: Button,
          event: "action",
          meta: {
            permission_prefix: "message_",
            buttons: [
              {
                label: "ویرایش",
                name: "create_and_update",
                icon: "pencil-alt",
                class: "btn-edit",
              },
              {
                name: "destroy",
                label: "حذف",
                icon: "trash",
                class: "btn-delete",
              },
            ],
          },
        },
      ],
      url: "messages",
      categoryUrl: "message/categories",
      query: {
        page: 1,
        search: "",
        length: 5,
      },
    };
  },
  mounted() {
    window.addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        this.createCategory();
      }
    });
  },
  created() {
    this.getMessages();
  },
  methods: {
    createAll() {
      this.pack_id = null;
      this.user_id = null;
    },
    getPacks() {
      this.$modal.showLoading();
      this.requestApiGet("pack")
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.packs = data.data;
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
        });
    },
    createCategory() {
      if (!(this.messageCategories.data && this.searchInArray(this.search))) {
        this.$modal.showLoading();
        this.requestApiPost("message/category", {
          title: this.search,
          description: this.search,
        })
          .then(({ data }) => {
            this.$modal.hideLoading();
            this.getMessageCategories();
            this.$toast.success("دسته بندی ایجاد شد");
          })
          .catch(({ response }) => {
            this.$modal.hideLoading();
          });
      }
    },

    searchInArray(value) {
      for (let item of this.messageCategories.data ?? []) {
        if (item.title.replace(/\s/g, "") == value.replace(/\s/g, ""))
          return true;
      }
      return false;
    },
    getMessageCategories(url = this.categoryUrl, query = this.query) {
      if (query.search === null) this.$modal.showLoading();
      return this.requestApiGet(url, query)
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.messageCategories = data;
          // this.messageCategories.data.push(data)
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
        });
    },
    openModal() {
      this.showCreateModal = !this.showCreateModal;
      this.update = false;
      this.getMessageCategories();
      this.getPacks();
    },
    getMessages(url = this.url, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then(({ data }) => {
          this.loading = false;
          this.data = data;
        })
        .catch(({ response }) => {
          this.loading = false;
        });
    },
    reloadTable(tableProps) {
      this.getMessages(this.url, tableProps);
    },
    store() {
      this.$modal.showLoading();
      this.requestApiPost(this.url, {
        title: this.title,
        description: this.description,
        user_id: this.user_id,
        pack_id: this.pack_id,
        category_id: this.category_id,
      })
        .then(({ data }) => {
          this.clearData();
          this.showCreateModal = false;
          this.$modal.hideLoading();
          this.getMessages();
          this.$toast.success("پیام با موفقیت ذخیره شد");
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
          this.$modal.hideLoading();
        });
    },
    clearData() {
      this.title = null;
      this.category_id = null;
      this.description = null;
      this.user_id = null;
      this.update = false;
      this.pack_id = null;
      this.errors = [];
    },
    cancelCreate() {
      this.clearData();
      this.showCreateModal = false;
    },
    updateMessage() {
      this.$modal.showLoading();
      this.requestApiPost(`${this.url}/${this.id}`, {
        title: this.title,
        description: this.description,
        user_id: this.user_id,
        category_id: this.category_id,
        pack_id: this.pack_id,
        _method: "put",
      })
        .then(({ data }) => {
          this.clearData();
          this.$modal.hideLoading();
          this.showCreateModal = false;
          this.getMessages();
          this.$toast.success("بروزرسانی موفقیت آمیز بود.");
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
          this.errors = response.data.errors;
        });
    },
    actions(data, type) {
      this[type](data);
    },
    create_and_update(data) {
      this.getPacks();
      this.getMessageCategories();
      this.id = data.id;
      this.showCreateModal = true;
      this.update = true;
      this.category_id = data.category_id;
      this.title = data.title;
      this.user_id = data.user_id;
      this.pack_id = data.pack_id;
      this.description = data.description;
    },
    async destroy(data) {
      if (await this.$modal.yesNo("آیا از حذف مطمعین هستید؟")) {
        this.$modal.showLoading();
        this.requestApiDelete(`messages/${data.id}`)
          .then(({ data }) => {
            this.$modal.hideLoading();
            this.$toast.success("با موفقیت حذف شد.");
            this.getMessages();
          })
          .catch(({ response }) => {
            this.$modal.hideLoading();
          });
      }
    },
  },
  watch: {
    description(val) {
      let info = getTextSmsInfo(val);
      this.smsCount = info.smsCount;
    },
    messageCategories(val) {
      return this.messageCategories.data.push({ id: -1, title: "همه" });
    },
    // page(val) {
    //   this.query.page = val;
    //   this.getMessageCategories(this.categoryUrl, this.query)
    // },
    search(val) {
      this.query.search = val;
      this.getMessageCategories(this.categoryUrl, this.query);
    },
  },
};
</script>

<style scoped></style>
